import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PaymentService } from './services/payment/payment.service';
import { PaymentRequest } from './models/PaymentRequest';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css'],
})
export class PaymentComponent {
  product: any;
  paymentForm: FormGroup;
  paymentRequest: PaymentRequest = {
    amount: 0,
    currency: "EGP",
    payment_methods: [4898103],
    items: [],
    billing_data: {
        first_name: "",
        last_name: "",
        phone_number: "",
        email: "",
    },
    customer: {
        first_name: "",
        last_name: "",
        email: ""
    }
  };

  constructor(private fb: FormBuilder, private paymentService: PaymentService, private router: Router) {
    const navigate = this.router.getCurrentNavigation();
    if (navigate?.extras.state) {
      const productKey = navigate?.extras.state!['productKey'];
      this.getProduct(productKey);
    }

    this.paymentForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  getProduct(productKey: string) {
    this.paymentService.getProduct(productKey).then((product: any) => {
      this.product = product;      
      product.quantity = 1;
      product.amount *= 100;
      this.paymentRequest.amount = product.amount;
      this.paymentRequest.items.push(product);
    });
  }

  onSubmit() {
    if (this.paymentForm.valid) {
      let form = this.paymentForm.value;
      this.paymentRequest.billing_data.first_name = form.firstName;
      this.paymentRequest.billing_data.last_name = form.lastName;
      this.paymentRequest.billing_data.email = form.email;
      this.paymentRequest.billing_data.phone_number = form.phone;
      
      this.paymentRequest.customer.first_name = form.firstName;
      this.paymentRequest.customer.last_name = form.lastName;
      this.paymentRequest.customer.email = form.email;

      this.paymentService.sendPaymentRequest(this.paymentRequest).subscribe((paymentLink: any) => {
        window.open(paymentLink.replace(" ", ""), '_blank');
      });
    }
  }
}
